import { useContext } from "react"
import { GlobalContext } from "../../contexts/Global"

export const useContextState = () => useContext(GlobalContext)